import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

export const columnasFijas: kea.Grid2Column<Entity>[] = [
    {
        title: "No. guia", cell: x => ({
            data: x.Folio, view: () =>
                <span style={{ fontFamily: "monospace" }} >
                    {x.Folio}
                    {
                        x.EsDeAcuse &&
                        <span className="label label-danger" >ACU</span>

                    }
                </span>
        })
    },
    { title: "Status", cell: x => ({ data: models.StatusGuia[x.Status] }) },
    { title: "Fecha creación", cell: x => ({ data: kea.toDate(x.FechaCreacion) }) },
    { title: "Cliente origen", cell: x => ({ data: x.NombreClienteOrigen }) },
    { title: "Cliente destino", cell: x => ({ data: x.NombreClienteDestino }) },
    { title: "Destino", cell: x => ({ data: x.DireccionDestinoDTO.Descripcion }) }
];

type Entity = models.GuiaDTO;
export interface Deps {
    onQuitar: (x: Entity) => void;
}

export function columnas(deps: Deps) {
    const ret: kea.Grid2Column<Entity>[] = [
        kea.columnaBotones([
            {
                iconClass: fa("trash"),
                onClick: deps.onQuitar,
                tooltip: "Quitar guia"
            }
        ]),
        ...columnasFijas
    ];
    return ret;
}


interface Props {
    value: models.GuiaDTO[];
    onQuitarGuia: (x: Entity) => void | Promise<void>;
}
class GuiasEnCargaDescargaZENoRx extends React.PureComponent<Props> {

    onQuitar = async (x: Entity) => {
        if (x.Status == models.StatusGuia.EnVehiculoZE ||
            x.Status == models.StatusGuia.EnViajeZERechazada ||
            x.Status == models.StatusGuia.EnViajeZEIncompleta
            ) {
            if (await kea.yesno("Quitar guia", `¿Quitar guia ${x.Folio}?`)) {
                await this.props.onQuitarGuia(x);
            }
        } else {
            //title: string, text?: string, type?: "warning" | "error" | "success" | "info")
            await kea.message("No se puede borrar de la carga","No se puede borrar la guia de la carga si no esta en el vehiculo","error");
        }
        
    }

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Grid2 cookieKey="multiselectorGuiaZE" items={this.props.value} columnas={cols} hideBusqueda={true} />
            </div>
        )
    }
}

export const GuiasEnCargaDescargaZE = componentToRx(GuiasEnCargaDescargaZENoRx);


// WEBPACK FOOTER //
// ./app/features/componentes/cargas/guiasCargaDescargaZE.tsx